import {useContext} from "react";
import {Link} from "@/components/atoms/link";
import classNames from "classnames";
import Image from "next/image";
import {MediaImage} from "@/components/templates/media/media--image";
import parse from "html-react-parser";
import {BlurMapContext} from "@/context/blur-map-context";
import {ARTICLE_TEASER_IMAGE_STYLE, HERO_PLACE_HOLDER_URL} from "@/types/image-styles";
import {absoluteURL} from "@/lib/absolute-url";
import {ProductTypeTaxonomyTerm} from "@/types/hygiena-types";


/**
 * The teaser that will display in the child category listing.
 *
 * @todo Duplicated now in Product Type/Name and now here, let's refactor this.
 *
 * @param taxonomy_term
 * @param className
 * @constructor
 */
export function TaxonomyIndustrySegmentsTeaser ({taxonomy_term, className}: {taxonomy_term: ProductTypeTaxonomyTerm, className?: string}) {
  const blurMap = useContext(BlurMapContext);
  const link = taxonomy_term?.path?.alias ?? "";
  const displayTitle = taxonomy_term?.field_industry_menu_title?.processed;
  const backgroundImage = taxonomy_term?.field_industry_hero_image;

  return (
    <Link href={link ?? "/"} className={classNames(
      "product-category-teaser font-semibold text-lg text-center relative border bg-primary flex justify-center items-end text-white rounded-sm h-[120px] md:h-48 overflow-hidden",
      className,
    )} key={taxonomy_term?.id}>
      {(backgroundImage?.image || backgroundImage?.bf_image) ? (
        <MediaImage
          media={backgroundImage}
          className="absolute w-full h-full hover:scale-105 transition-all duration-1000"
          priority
          imageStyle={ARTICLE_TEASER_IMAGE_STYLE}
          width={300}
          height={300}
          sizes="(min-width: 968px) 50vw, (min-width: 768px) 20vw, 20vw"
          style={{objectFit: "cover", width: "100%", height: "100%"}}
        />
      ) : (
        <Image
          src={absoluteURL(HERO_PLACE_HOLDER_URL, true)}
          blurDataURL={blurMap?.hero_placeholder?.base64}
          placeholder={blurMap?.hero_placeholder?.base64 ? "blur" : "empty"}
          width={280}
          height={190}
          className={"absolute inset-0 w-full h-full"} style={{objectFit: "cover", height: "100%", width: "100%"}}
          alt={taxonomy_term?.name}/>
      )}
      <div className="w-full py-4 px-2 text-left bg-hygienaLight/40 backdrop-blur text-black font-bold">
        {displayTitle ? parse(displayTitle) : taxonomy_term.name}
      </div>
    </Link>
  )
}